import { render, staticRenderFns } from "./EditUiBanner.vue?vue&type=template&id=45e1eaf6"
import script from "./EditUiBanner.vue?vue&type=script&lang=ts"
export * from "./EditUiBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports